import * as React from "react";

// 담당자(사무장) 표시 — 색 점 + 라벨(메모). 미배정이면 회색 "미배정".
export function AssigneeBadge({
  label,
  color,
}: {
  label: string | null;
  color: string | null;
}): React.ReactElement {
  if (!label) {
    return <span className="text-[12px] text-ink-subtle">미배정</span>;
  }
  return (
    <span className="inline-flex items-center gap-1.5 text-[12px] text-ink">
      <span
        className="w-2 h-2 rounded-full shrink-0"
        style={{ backgroundColor: color ?? "#9ca3af" }}
        aria-hidden
      />
      <span className="truncate max-w-[160px]" title={label}>
        {label}
      </span>
    </span>
  );
}
